import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { Employee } from '@akiba/models_bimbo';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { MatTable, MatDialog } from '@angular/material';
import * as moment from 'moment';

import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { SsUserRegistrationComponent } from '../ss-user-registration/ss-user-registration.component';

@Component({
  selector: 'app-ss-user',
  templateUrl: './ss-user.component.html',
  styleUrls: ['./ss-user.component.scss']
})


export class SsUserComponent implements OnInit {

  @Input() contentLocation: AppState;
  @Input() shareSavingsParameters: any;
  @ViewChild('ssUserTable', { static: false }) ssUserTable: MatTable<any>;
  @ViewChild('SsUserRegistrationComponent', { static: true }) SsUserRegistrationComponent: SsUserRegistrationComponent;

  currentEmployee: Employee;
  shareSavingsUser: any;
  newParameter: any;
  newRegister: boolean = false;
  firstRegisterEnabled = false;
  adminButton = false;
  ssUserColumns: string[] = ['inversion', 'importe', 'cuotas', 'fecha', 'activo', 'detalle'];

  constructor(public logicService: LogicService, private dataService: DataSourceService, private authService: AuthenticationService) {

    this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee ? this.logicService.dataManager.proxyDataLoader.employee : this.logicService.dataManager.principalDataLoader.employee;
  }

  ngOnInit() {

    this.userShareSaving();
    this.adminButton = this.authService.appLevel.administrator ? true : false;

  }

  async userShareSaving() {

    const shareSavingsData = await this.dataService.shareSavingsUser(this.currentEmployee.uid);
    this.shareSavingsUser = shareSavingsData ? shareSavingsData.docs.map(x => {
      const data = x.data();
      data.dateS = moment(data.subscriptionDate.toDate()).format('MMM YYYY');
      return data;
    }) : [];

    if (this.shareSavingsUser) {
      this.newShareSaving();
      this.firstRegister();
    }



  }

  detailssUser(event: any = {}) {
    if (event.parametersID) {
      this.newParameter = {
        activeParameterID: event.parametersID,
        activeScheduleDateID: event.scheduleDateID
      }

    } else {
      this.newParameter = {
        activeParameterID: this.shareSavingsParameters.parametersID,
        activeScheduleDateID: this.shareSavingsParameters.scheduleDateID
      }

    }
  }

  firstRegister() {
    if (this.shareSavingsUser.length === 0 && this.shareSavingsParameters.scheduleDateID != undefined && this.shareSavingsParameters.parametersID != undefined) {

      this.newParameter = {
        activeParameterID: this.shareSavingsParameters.parametersID,
        activeScheduleDateID: this.shareSavingsParameters.scheduleDateID
      }
      this.firstRegisterEnabled = true;

    }

  }


  newShareSaving() {

    if (this.shareSavingsParameters.habilitado) {
      const ssUser = this.shareSavingsUser.filter(ssUser => ssUser.active === true && ssUser.parametersID === this.shareSavingsParameters.parametersID && ssUser.scheduleDateID === this.shareSavingsParameters.scheduleDateID);
      if (ssUser.length == 0) {
        this.newRegister = true;
      }



    }

  }


}
